import { Streamer } from 'components/template/streamer';
import {
  ICasinoReviewGraph,
  IStreamer,
  IStreamerReview,
} from 'constants/types';
import { ssrApi } from 'api/ssr';
import { URLS } from 'api/constants';
import { apiGet } from 'lib/api/client';
import { PaginationResponse } from 'lib/api/types';
import { ParsedUrlQuery } from 'querystring';
import {
  isValidEntity,
  notFoundResult,
  unwrapEntity,
} from 'utils/ssr-not-found';

const REVIEWS_LIMIT = 4;

export default function StreamerPage({
  streamer,
  reviewGraphResults,
  streamerReviews,
  streamerReviewsCount,
}: {
  streamer: IStreamer;
  reviewGraphResults: ICasinoReviewGraph[];
  streamerReviews: IStreamerReview[];
  streamerReviewsCount: number;
}) {
  return (
    <Streamer
      streamer={streamer}
      reviewGraphResults={reviewGraphResults}
      streamerReviews={streamerReviews}
      streamerReviewsCount={streamerReviewsCount}
    />
  );
}

export async function getServerSideProps({ query }: { query: ParsedUrlQuery }) {
  const { id } = query;

  const streamer = await ssrApi.streamers.getById(id?.toString());

  if (!isValidEntity(streamer)) {
    return notFoundResult();
  }

  const resolvedStreamer = unwrapEntity(streamer)!;
  const [graphData, reviewsData] = await Promise.all([
    apiGet<PaginationResponse<ICasinoReviewGraph>>(
      `${URLS.REVIEWS_GRAPG_BY_STREAMER}${resolvedStreamer._id}`
    ).catch(() => ({ results: [] })),
    apiGet<PaginationResponse<IStreamerReview>>(
      `${URLS.REVIEWS_BY_STREAMER}${resolvedStreamer._id}`,
      { page: 1, limit: REVIEWS_LIMIT }
    ).catch(() => ({ results: [], count: 0 })),
  ]);

  const streamerReviews = reviewsData?.results ?? [];

  return {
    props: {
      streamer: resolvedStreamer,
      reviewGraphResults: graphData?.results ?? [],
      streamerReviews,
      streamerReviewsCount: Number(
        reviewsData?.count ?? streamerReviews.length ?? 0
      ),
    },
  };
}
